import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, DialogActions } from "@mui/material";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import ConfirmationDialog from "Components/Common/ConfirmationDialog";
import CommentInputForReason from "Components/Common/CommentInputForReason";
import { applicationApprovalStatusTypes } from "common/constant";

import { getAllowedStatusForUTAApplication } from "utils/getAllowedStatusForUTAApplication";
import { getOptionLabel } from "common/enums";
import { usePutUpdateUtilityTunnelApplicationStatusMutation } from "apis/UtilityTunnel";

const UtilityTunnelApprovalActionModal = ({
  applicationData,
  handleClose,
  t,
}) => {
  const [updateStatus, { isLoading: statusLoading }] =
    usePutUpdateUtilityTunnelApplicationStatusMutation();

  const [isRejectionCommentModalVisible, setIsRejectionCommentModalVisible] =
    useState(false);
  const [isApproveBtnClicked, setIsApproveBtnClicked] = useState(false);

  const {
    approvedBy,
    rejectedBy,
    id,
    accessCardHolderType,
    employeeContractorDetail,
  } = applicationData;

  const { roles } = useSelector((state) => state.Login);

  const { canApproved, canRejected } = getAllowedStatusForUTAApplication(
    {
      approvedBy,
      rejectedBy,
    },
    roles,
    getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
      "Employee",
    employeeContractorDetail?.departmentId
  );

  const submitHandlerForRejection = async (comment) => {
    try {
      await updateStatus({
        accessDetailId: id,
        status: applicationApprovalStatusTypes["Rejected"],
        comment,
      });
      handleClose();
    } catch (err) {}
  };

  const submitHandlerForApprove = async () => {
    try {
      await updateStatus({
        accessDetailId: id,
        status: applicationApprovalStatusTypes["Approved"],
      });
      handleClose();
    } catch (err) {}
  };

  return (
    <>
      {isApproveBtnClicked && (
        <>
          <ConfirmationDialog
            message="Are you sure you want to approve application?"
            onCancel={() => {
              setIsApproveBtnClicked(false);
            }}
            onConfirm={submitHandlerForApprove}
            isOpen={isApproveBtnClicked}
            title="Warning"
            variant="warning"
            isLoading={statusLoading}
          />
        </>
      )}

      <CommentInputForReason
        handleClose={() => {
          setIsRejectionCommentModalVisible(false);
        }}
        handleSubmit={submitHandlerForRejection}
        isOpen={isRejectionCommentModalVisible}
        isLoading={statusLoading && isRejectionCommentModalVisible}
        title="Add Reason for Rejection"
        errorMessage="Please enter reason for rejection"
      />

      <DialogActions className="border-top">
        {canApproved && (
          <Button
            variant="contained"
            color="success"
            onClick={() => setIsApproveBtnClicked(true)}
          >
            {t("Approve")}
          </Button>
        )}

        {canRejected && (
          <Button
            variant="contained"
            color="error"
            onClick={() => setIsRejectionCommentModalVisible(true)}
          >
            {t("Reject")}
          </Button>
        )}
      </DialogActions>
    </>
  );
};

UtilityTunnelApprovalActionModal.propTypes = {
  applicationData: PropTypes.object,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};
export default withTranslation()(UtilityTunnelApprovalActionModal);
